import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from '../../common/header/header.component';
import { SidebarComponent } from '../../common/slidebar/sidebar.components';
import { FaceCompareService } from '../../../services/face-compare/face-compare.service';
import { FaceSearchTabsComponent } from '../face-search-tabs/face-search-tabs.component';
import { UserAccountService } from '../../../services/user-account/user-account.service';
import { SearchServiceStatusService } from '../../../services/search-service-status/search-service-status.service';
import { CreditsLabelPipe } from '../../../pipes/credits-label.pipe';

@Component({
  selector: 'app-video-scanner',
  imports: [CommonModule,
    RouterOutlet,
    HeaderComponent,
    SidebarComponent,
    FaceSearchTabsComponent, CreditsLabelPipe],
  templateUrl: './video-scanner.component.html',
  styleUrl: './video-scanner.component.css',
})
export class VideoScannerComponent implements OnInit, OnDestroy {
  availableCredits: number | null = null;
  creditsLoading = true;
  isServiceDisabled = false;
  showBack = false;

  private subscription = new Subscription();

  constructor(
    private faceCompareService: FaceCompareService,
    private userAccountService: UserAccountService,
    private router: Router,
    private route: ActivatedRoute,
    private searchServiceStatusService: SearchServiceStatusService,
  ) {
    this.faceCompareService.setFeatureContext('video_scanner');
  }

  ngOnInit(): void {
    this.subscription.add(
      this.searchServiceStatusService.searchServices$.subscribe((searchServices) => {
        if (searchServices) {
          this.isServiceDisabled = searchServices.video_scanner === false;
        }
      }),
    );

    this.subscription.add(
      this.route.queryParamMap.subscribe(() => this.updateShowBack()),
    );

    this.subscription.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => this.updateShowBack()),
    );

    this.updateShowBack();
    this.getAvailableCredits();
  }

  private updateShowBack(): void {
    const onResults = this.router.url.includes('/video-scanner/results');
    const hasStaleId = Boolean(
      this.route.snapshot.queryParamMap.get('video_scanner_id'),
    );
    this.showBack = onResults && hasStaleId;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getAvailableCredits(): void {
    this.creditsLoading = true;
    this.userAccountService.getUserProfile().subscribe({
      next: (response) => {
        const subscription = response?.data?.subscriptions?.[0] || {};
        this.availableCredits = this.userAccountService.pickAvailableCredits(response);
        this.creditsLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.availableCredits = 0;
        this.creditsLoading = false;
      },
    });
  }

  onBuyCreditsButtonClick(): void {
    this.router.navigate(['/plan-pricing']);
  }

  onBack(): void {
    this.router.navigate(['/osint-image-search/video-scanner/upload'], {
      queryParams: {},
    });
  }
}
